import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HSCodeActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/HSCode/HSCodeBrowser")
	}

	render() {
		return (
			<Activity 
				name="HSCode"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HSCodeActivity)